import PropTypes from 'prop-types';

import { Container, Grid, useMediaQuery } from '@material-ui/core';
import { useTheme, withStyles } from '@material-ui/core/styles';

import { headerHeightPx, mobileHeaderHeightPx } from 'common/constants/ui';
import { HomeHeader } from 'widgets/home';
import useHideWebWidget from 'common/hooks/useHideWebWidget';

import Footer from '../Footer';
import MetaTags from '../MetaTags';
import styles from './styles';

const BasePageContainer = ({
  children,
  header,
  footer,
  disableFooter,
  bgColor,
  maxWidth,
  classes,
  ...rest
}) => {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));

  useHideWebWidget(isTabletOrMobile);

  return (
    <Grid container direction="column" wrap="nowrap" className={classes.container} {...rest}>
      <MetaTags />

      <Grid
        item
        xs={12}
        style={{
          maxHeight: isTabletOrMobile ? mobileHeaderHeightPx : headerHeightPx,
        }}
      >
        {header || <HomeHeader hideOnScroll />}
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          backgroundColor: bgColor,
        }}
      >
        <Container disableGutters className={classes.contentContainer} style={{ maxWidth }}>
          {children}
        </Container>
      </Grid>

      {!disableFooter && (
        <Grid item xs={12}>
          {footer || <Footer />}
        </Grid>
      )}
    </Grid>
  );
};

BasePageContainer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.node,
  disableFooter: PropTypes.bool,
  bgColor: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    contentContainer: PropTypes.string,
  }).isRequired,
};

BasePageContainer.defaultProps = {
  children: null,
  header: null,
  footer: null,
  disableFooter: false,
  bgColor: 'inherit',
  maxWidth: 1200,
};

export default withStyles(styles)(BasePageContainer);
